import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { zIndexValues } from 'utils/styles';
import { ja } from 'date-fns/locale/ja';
import { enUS } from 'date-fns/locale/en-US';
import { zhCN } from 'date-fns/locale/zh-CN';
import { parseISO } from 'date-fns';
import { LANGUAGE_CODE, getCurrentLocale } from 'utils/intl';

const LOCALE_MAP = {
  [LANGUAGE_CODE.ENGLISH]: enUS,
  [LANGUAGE_CODE.JAPANESE]: ja,
  [LANGUAGE_CODE.CHINESE]: zhCN,
  [LANGUAGE_CODE.INDONESIAN]: enUS,
};

export const CustomDatePicker = ({
  isDatePickerOpen,
  setIsDatePickerOpen,
  selectedDate,
  setSelectedDate,
  labelText,
  minDate,
  maxDate,
  zIndex,
  fullWidth = false,
  isMonthOnly,
  readOnly = true, // Add this new prop
}) => {
  const currentLanguage = getCurrentLocale();
  ``;

  const handleDateChange = (date) => {
    setSelectedDate(date);
  };

  // Ensure selectedDate is a Date object, not a string
  const normalizedSelectedDate =
    selectedDate instanceof Date
      ? selectedDate
      : selectedDate
      ? parseISO(selectedDate)
      : null;

  // Ensure minDate and maxDate are Date objects
  const normalizedMinDate =
    minDate instanceof Date ? minDate : minDate ? parseISO(minDate) : null;

  const normalizedMaxDate =
    maxDate instanceof Date ? maxDate : maxDate ? parseISO(maxDate) : null;

  // Only add open/close handlers if the props are provided
  const datePickerProps = {
    label: labelText,
    value: normalizedSelectedDate,
    onChange: handleDateChange,
    minDate: normalizedMinDate,
    maxDate: normalizedMaxDate,
    views: isMonthOnly ? ['year', 'month'] : ['year', 'month', 'day'],
    openTo: isMonthOnly ? 'month' : 'day',
    slotProps: {
      textField: {
        readOnly: readOnly,
        variant: 'outlined',
        fullWidth: fullWidth,
        sx: {
          '& .MuiPickersSectionList-root': {
            fontSize: '14px !important',
          },
        },
      },
      popper: {
        sx: {
          zIndex: zIndex || zIndexValues.iconPopover,
        },
      },
    },
  };

  if (isDatePickerOpen !== undefined && setIsDatePickerOpen) {
    datePickerProps.open = isDatePickerOpen;
    datePickerProps.onOpen = () => setIsDatePickerOpen(true);
    datePickerProps.onClose = () => setIsDatePickerOpen(false);
  }

  return (
    <LocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={LOCALE_MAP[currentLanguage]}>
      <DatePicker {...datePickerProps} />
    </LocalizationProvider>
  );
};

CustomDatePicker.propTypes = {
  isDatePickerOpen: PropTypes.bool,
  setIsDatePickerOpen: PropTypes.func,
  selectedDate: PropTypes.oneOfType([
    PropTypes.instanceOf(Date),
    PropTypes.string,
  ]),
  setSelectedDate: PropTypes.func.isRequired,
  labelText: PropTypes.string,
  minDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  maxDate: PropTypes.oneOfType([PropTypes.instanceOf(Date), PropTypes.string]),
  zIndex: PropTypes.number,
  fullWidth: PropTypes.bool,
  isMonthOnly: PropTypes.bool,
  readOnly: PropTypes.bool, // Add this line
};
